export default __webpack_public_path__ + "static/media/FiraSans-MediumItalic.6047f825.woff";